<template>
  <v-container pa-0 fluid fill-height class="container-controlbar">
    <!-- Custom Control Bar -->
    <v-row class="container-slider" no-gutters>
      <v-slider
        class="seek-slider"
        v-model="seekTime"
        @change="setSeekTime($event)"
        @mousedown="mousedown($event)"
        @mouseup="mouseup($event)"
        @click="removeByClickingSlider"
        @input="setDragSeekBar"
        :step="1"
        min="0"
        :max="duration * 1000"
        hide-details
        track-color="#aaaaaa"
      ></v-slider>
    </v-row>

    <comment-play :sectionIndex="stIndex" :seekTime="seekTime" :upHere.sync="upHere"></comment-play>

    <v-row :class="isMobile ? 'mt-1 mb-2 py-1' : 'mt-1 mb-2'" no-gutters>
      <v-col cols="12">
        <v-row align="center" no-gutters justify-items="center">
          <v-tooltip
            color="#131b1e"
            attach="#btn-play"
            :open-on-hover="isMobile ? false : true"
            :open-on-click="isMobile ? false : true"
          >
            <template v-slot:activator="{ on: onTooltip }">
              <v-btn
                id="btn-play"
                plain
                @click.stop="pauseAndResume()"
                :class="$vuetify.breakpoint.width < 960 ? 'px-1' : 'pl-2'"
                v-on="{ ...onTooltip }"
                align="center"
              >
                <span
                  ref="play_icon"
                  id="playButton"
                  class="material-icons-round"
                  :style="
                    $vuetify.breakpoint.width < 960
                      ? 'font-size: 22px; font-weight: 400; cursor: pointer'
                      : 'font-size: 32px; font-weight: 400; cursor: pointer'
                  "
                  translate="no"
                >
                  {{ isPauseIcon ? 'pause' : 'play_arrow' }}
                </span>
              </v-btn>
            </template>
            <span>{{ isPauseIcon ? 'Pause(k)' : 'Play(k)' }}</span>
          </v-tooltip>
          <v-col cols="auto">
            <v-hover v-slot="{ hover }" v-model="isShowVolume">
              <v-card color="transparent" flat :width="hover ? 150 : 50">
                <v-row class="d-flex flex-nowrap" justify="start" align="center" no-gutters>
                  <v-tooltip
                    color="#131b1e"
                    attach="#btn-mute"
                    :open-on-hover="isMobile ? false : true"
                    :open-on-click="isMobile ? false : true"
                  >
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn id="btn-mute" plain v-on="{ ...onTooltip }" @click="onVolumeClick">
                        <span
                          class="material-icons-round"
                          :style="
                            $vuetify.breakpoint.width < 960
                              ? 'font-size: 16px; font-weight: 400; cursor: pointer; color: #eee'
                              : 'font-size: 25px; font-weight: 400; cursor: pointer; color: #eee'
                          "
                          translate="no"
                        >
                          {{ isMute ? 'volume_off' : 'volume_up' }}
                        </span>
                      </v-btn>
                    </template>
                    <span>{{ isMute ? 'Unmute(m)' : 'Mute(m)' }}</span>
                  </v-tooltip>
                  <v-col class="pl-2 pr-5" cols="9" align="center" style="z-index: 200 !important">
                    <v-slide-x-transition>
                      <v-slider
                        v-if="hover"
                        thumb-label
                        hide-details
                        v-model="localVolume"
                        class="volume"
                        color="#25c685"
                        min="0"
                        max="100"
                        height="28"
                      ></v-slider>
                    </v-slide-x-transition>
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
          <v-col
            class="container-duration px-2"
            cols="auto"
            v-if="$vuetify.breakpoint.width > 600 ? true : isShowVolume ? false : true"
          >
            <span :style="$vuetify.breakpoint.width < 960 ? 'font-size: 12px' : ''">
              {{ calcSeekTime }} / {{ calcDurationTime }}
            </span>
          </v-col>

          <v-spacer />

          <v-menu top nudge-top="35" max-height="200" max-width="200">
            <template v-slot:activator="{ on: onMenu }">
              <v-btn plain class="" v-on="{ ...onMenu }" elevation="0">
                <span
                  :class="
                    $vuetify.breakpoint.width < 960 ? 'material-icons-round md-30' : 'mr-1 material-icons-round md-36'
                  "
                  translate="no"
                  :style="
                    $vuetify.breakpoint.width < 960
                      ? 'font-size: 24px; font-weight: 400; cursor: pointer; padding: 6px'
                      : 'font-size: 30px; font-weight: 400; cursor: pointer'
                  "
                >
                  more_horiz
                </span>
              </v-btn>
            </template>

            <v-list dense dark style="background-color: rgb(29, 41, 47); padding: 0">
              <v-list-item color="white" link class="py-2" @click="toggleVisualComment">
                <v-list-item-title>
                  {{ showVisualComment ? 'Hide Comment' : 'Show Comment' }}
                </v-list-item-title>
              </v-list-item>

              <!-- <v-list-item color="white" link class="py-2" @click="toggleEmoji">
                <v-list-item-title>
                  {{ showEmoji ? 'Hide Emoji' : 'Show Emoji' }}
                </v-list-item-title>
              </v-list-item> -->

              <v-list-item color="white" link class="py-2" @click="toggleSummary">
                <v-list-item-title>
                  {{ showSummary ? 'Hide Summary' : 'Show Summary' }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- <v-tooltip
            color="#131b1e"
            attach="#controllerSelect"
            :open-on-hover="isMobile ? false : true"
            :open-on-click="isMobile ? false : true"
          >
            <template v-slot:activator="{ on: onTooltip }">
              <v-btn v-on="onTooltip" plain class="" elevation="0" @click="toggleVisualComment">
                <span
                  :class="
                    $vuetify.breakpoint.width < 960 ? 'material-icons-round md-30' : 'mr-1 material-icons-round md-36'
                  "
                  translate="no"
                  :style="
                    $vuetify.breakpoint.width < 960
                      ? 'font-size: 16px; font-weight: 400; cursor: pointer; padding: 6px 2px'
                      : 'font-size: 24px; font-weight: 400; cursor: pointer'
                  "
                >
                  {{ showVisualComment ? 'comment' : 'comments_disabled' }}
                </span>
              </v-btn>
            </template>
            <span>{{ showVisualComment ? 'Hide Comment' : 'Show Comment' }}</span>
          </v-tooltip> -->

          <!-- <v-tooltip
            color="#131b1e"
            attach="#controllerSelect"
            :open-on-hover="isMobile ? false : true"
            :open-on-click="isMobile ? false : true"
          >
            <template v-slot:activator="{ on: onTooltip }">
              <v-btn v-on="onTooltip" plain class="" elevation="0" @click="toggleEmoji">
                <span
                  :class="
                    $vuetify.breakpoint.width < 960 ? 'material-icons-round md-30' : 'mr-1 material-icons-round md-36'
                  "
                  translate="no"
                  :style="
                    $vuetify.breakpoint.width < 960
                      ? 'font-size: 16px; font-weight: 400; cursor: pointer; padding: 6px 2px'
                      : 'font-size: 24px; font-weight: 400; cursor: pointer'
                  "
                >
                  {{ showEmoji ? 'face' : 'face_retouching_off' }}
                </span>
              </v-btn>
            </template>
            <span>{{ showEmoji ? 'Hide Emoji' : 'Show Emoji' }}</span>
          </v-tooltip> -->

          <!-- <v-tooltip
            color="#131b1e"
            attach="#controllerSelect"
            :open-on-hover="isMobile ? false : true"
            :open-on-click="isMobile ? false : true"
          >
            <template v-slot:activator="{ on: onTooltip }">
              <v-btn v-on="onTooltip" plain class="" elevation="0" @click="toggleSummary">
                <span
                  :class="
                    $vuetify.breakpoint.width < 960 ? 'material-icons-round md-30' : 'mr-1 material-icons-round md-36'
                  "
                  translate="no"
                  :style="
                    $vuetify.breakpoint.width < 960
                      ? 'font-size: 16px; font-weight: 400; cursor: pointer; padding: 6px 2px'
                      : 'font-size: 24px; font-weight: 400; cursor: pointer'
                  "
                >
                  {{ showSummary ? 'wysiwyg' : 'web_asset_off' }}
                </span>
              </v-btn>
            </template>
            <span>{{ showSummary ? 'Hide Summary' : 'Show Summary' }}</span>
          </v-tooltip> -->
          <!-- 자막 추가 -->
          <v-col class="" cols="auto" id="controllerSelect">
            <v-menu
              v-if="$vuetify.breakpoint.width >= 960"
              top
              nudge-top="35"
              max-height="200"
              max-width="200"
              :open-on-hover="true"
            >
              <template v-slot:activator="{ on: onMenu }">
                <v-btn
                  plain
                  id="ccSelect"
                  class="cc-select"
                  v-on="{ ...onMenu }"
                  elevation="0"
                  :disabled="isInIframe && !subTitleData"
                  @click="setShowCaption"
                >
                  <span
                    :class="
                      $vuetify.breakpoint.width < 960 ? 'material-icons-round md-30' : 'mr-1 material-icons-round md-36'
                    "
                    translate="no"
                    :style="
                      $vuetify.breakpoint.width < 960
                        ? showCaption
                          ? 'font-size: 24px; font-weight: 400; cursor: pointer; padding: 6px; color: #fff'
                          : 'font-size: 24px; font-weight: 400; cursor: pointer; padding: 6px; color: rgba(255, 255, 255, 0.3)'
                        : showCaption
                        ? 'font-size: 30px; font-weight: 400; cursor: pointer; color: #fff'
                        : 'font-size: 30px; font-weight: 400; cursor: pointer; color: rgba(255, 255, 255, 0.3)'
                    "
                  >
                    closed_caption
                  </span>
                </v-btn>
              </template>

              <v-list dense dark style="background-color: rgb(29, 41, 47); padding: 0">
                <v-list-item
                  color="white"
                  v-for="(item, index) in subTitleData"
                  :key="index"
                  link
                  class="pa-0"
                  :style="item.code == selectedSubtitle ? 'background-color: #111a1f' : ''"
                >
                  <v-list-item-title class="px-4 py-4" @click="selectSubTitle(item)">
                    <span>{{ item.country }}</span>
                  </v-list-item-title>
                  <span
                    v-if="isMtOrganizer || isWsManager || isWsOwner || isClipUploader"
                    @click="deleteSubtitle(item)"
                    class="material-icons-round py-4 px-2"
                    style="color: #ccc; font-size: 16px; cursor: pointer"
                    translate="no"
                  >
                    close
                  </span>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                  v-if="!isInIframe"
                  @click="openUploadSubtitleDialog"
                  color="white"
                  link
                  class="btn-uploadCc py-2"
                >
                  <v-list-item-title>
                    {{ 'Upload Subtitle' }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu class="menu-playback" top nudge-top="30" max-height="150" max-width="80" attach="#controllerSelect">
              <template v-slot:activator="{ on: onMenu }">
                <v-tooltip
                  color="#131b1e"
                  attach="#controllerSelect"
                  :open-on-hover="isMobile ? false : true"
                  :open-on-click="isMobile ? false : true"
                >
                  <template v-slot:activator="{ on: onTooltip }">
                    <v-btn
                      class="playback-select ma-0 pa-0"
                      :width="$vuetify.breakpoint.width < 960 ? 30 : 50"
                      :height="$vuetify.breakpoint.width < 960 ? 25 : 25"
                      color="#1f2e35"
                      v-on="{ ...onMenu, ...onTooltip }"
                      elevation="0"
                    >
                      x {{ playbackItem }}
                    </v-btn>
                  </template>
                  <span>{{ 'Playback speed' }}</span>
                </v-tooltip>
              </template>

              <v-list dense dark style="background-color: rgb(29, 41, 47)">
                <v-list-item
                  @click="playbackItem = item"
                  color="white"
                  v-for="(item, index) in playbackItems"
                  :key="index"
                  link
                >
                  <v-list-item-title>x {{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- 추후에 버튼 많아지면 세팅 아이콘으로 대체 -->
            <!-- <v-menu top nudge-top="25" max-height="150" max-width="80" attach="#controllerSelect">
              <template v-slot:activator="{ on: onMenu }">
                <v-tooltip color="#131b1e" attach="#controllerSelect">
                  <template v-slot:activator="{ on: onTooltip }">
                    <v-btn
                      plain
                      class="playback-select"
                      color="#1f2e35"
                      v-on="{ ...onMenu, ...onTooltip }"
                      elevation="0"
                    >
                      <span class="material-icons-round" style="font-size: 24px; font-weight: 400">settings</span>
                    </v-btn>
                  </template>
                  <span>{{ 'Settings' }}</span>
                </v-tooltip>
              </template>

              <v-list dense dark>
                <v-list-item
                  @click="playbackItem = item"
                  color="white"
                  v-for="(item, index) in playbackItems"
                  :key="index"
                  link
                >
                  <v-list-item-title>x {{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
          </v-col>
          <v-tooltip
            color="#131b1e"
            attach="#btn-fullscreen"
            :open-on-hover="isMobile ? false : true"
            :open-on-click="isMobile ? false : true"
          >
            <template v-slot:activator="{ on: onTooltip }">
              <v-btn id="btn-fullscreen" plain v-on="{ ...onTooltip }" @click="$emit('setFullScreen')">
                <span
                  :class="
                    $vuetify.breakpoint.width < 960 ? 'material-icons-round md-30' : 'mr-1 material-icons-round md-36'
                  "
                  translate="no"
                  :style="
                    $vuetify.breakpoint.width < 960
                      ? 'font-size: 22px; font-weight: 400; cursor: pointer; padding: 6px 2px'
                      : 'font-size: 34px; font-weight: 400; cursor: pointer'
                  "
                >
                  {{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}
                </span>
              </v-btn>
            </template>
            <span>{{ isFullScreen ? 'Exit full screen(f/esc)' : 'Full screen(f)' }}</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>

    <!-- 자막 추가 Dialog -->
    <upload-subtitle-dialog
      @close="isUploadSubtitleDialog = false"
      @finishUploadSubtitle="finishUploadSubtitle"
      :isUploadSubtitleDialog="isUploadSubtitleDialog"
    ></upload-subtitle-dialog>
  </v-container>
</template>

<script>
import { deleteSubtitle } from '@/services/clipApi'
import { time, isMobile } from '@/common/lib/strLib'
import UploadSubtitleDialog from '@/views/modal/UploadSubtitleDialog'
import { mapGetters, mapActions } from 'vuex'
import Toast from '@/views/meeting/component/Toast'
import CommentPlay from './CommentPlay.vue'

export default {
  components: { UploadSubtitleDialog, CommentPlay },
  name: 'VideoControlBar',
  props: ['stIndex', 'upHere', 'hideComment'],
  data() {
    return {
      isSeeking: false,
      localVolume: null,
      seekTime: 0,
      seekTimeDecimal: 0,
      totalTime: this.duration,
      playbackItems: [2.0, 1.75, 1.5, 1.25, 1.0, 0.75, 0.5],
      playbackItem: this.$store.getters.playback,
      ccItems: ['Korean', 'English'], // 임시 데이터
      ccItem: '', // 임시 데이터
      seekInterval: null,
      avatarPosition: [],
      time: null,
      isUploadSubtitleDialog: false,
      widthOfVideoControlBar: 0,
      show: false,
      timeOutValueForVideoControlBar: 0,
      isShowVolume: false,
      showVisualComment: true,
      showEmoji: true,
      showSummary: true,
      showCaption: true,
      selectedSubtitle: null,
    }
  },
  created() {
    if (localStorage.getItem('volume')) this.$store.dispatch('setVolume', Number(localStorage.getItem('volume')))
    this.localVolume = this.volume !== undefined && this.volume !== null ? this.volume : 100
    // this.getCommentList(false)

    this.$root.$refs[`VideoControlBar-${this.stIndex}`] = this

    this.seekInterval = setInterval(() => {
      if (this.isPauseIcon) {
        this.seekTime += 100 * this.playbackItem
      }
    }, 100)
    if (localStorage.getItem('cc')) {
      this.showCaption = localStorage.getItem('cc') == 'true' || localStorage.getItem('cc') == true ? true : false
    } else {
      this.showCaption = true
      localStorage.setItem('cc', this.showCaption)
    }

    if (localStorage.getItem('ccCode')) {
      this.selectedSubtitle = localStorage.getItem('ccCode')
    }
  },
  mounted() {
    document.addEventListener('keydown', this.keyEvent)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWidth)
    document.removeEventListener('keydown', this.keyEvent)

    if (this.seekInterval !== undefined && this.seekInterval !== null) {
      clearInterval(this.seekInterval)
      this.seekInterval = null
    }
  },
  methods: {
    ...mapActions(['setSubTitleData']),
    keyEvent(e) {
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        // K : 플레이/일시정지
        if (!e.ctrlKey && !e.metaKey && e.keyCode == 75) {
          this.pauseAndResume()
          e.preventDefault()
          // M : mute/unmute
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 32 && !this.isFeedback) {
          this.pauseAndResume()
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 77) {
          this.onVolumeClick()
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 38) {
          if (this.localVolume <= 95) {
            this.localVolume += 5
          } else {
            this.localVolume = 100
          }
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 40) {
          if (this.localVolume >= 5) {
            this.localVolume -= 5
          } else {
            this.localVolume = 0
          }
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 39) {
          this.seekTime += 5000
          this.setSeekTime(this.seekTime)
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 37) {
          this.seekTime -= 5000
          this.setSeekTime(this.seekTime)
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 188 && e.shiftKey) {
          let curruntPlaybackItem = this.playbackItem
          if (curruntPlaybackItem == 0.5) {
            return
          } else {
            this.playbackItem = curruntPlaybackItem - 0.25
          }
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 190 && e.shiftKey) {
          let curruntPlaybackItem = this.playbackItem
          if (curruntPlaybackItem == 2.0) {
            return
          } else {
            this.playbackItem = curruntPlaybackItem + 0.25
          }
          e.preventDefault()
        }
      }
    },
    boxCommentLeftPosition(comment) {
      let leftValue = (comment.boxData.time / this.duration) * 100
      return leftValue
    },

    getPosition(time, duration, elWidth) {
      let leftValue
      const barFillLocation = (time / duration) * elWidth

      if (barFillLocation - 12 < 0) {
        leftValue = 0
      } else if (barFillLocation > elWidth - 12) {
        leftValue = elWidth - 24
      } else {
        leftValue = barFillLocation - 12
      }

      return leftValue
    },

    getWidth() {
      // const getWidth = document.querySelector('.container-comment-avatar')
      this.$nextTick(() => {
        const getWidth = this.$refs[`avatarContainer-${this.stIndex}`]
        this.widthOfVideoControlBar = getWidth && getWidth?.getBoundingClientRect()?.width
        return this.widthOfVideoControlBar
      })
    },

    openUploadSubtitleDialog() {
      if (this.isMtOrganizer || this.isWsManager || this.isWsOwner || this.isClipUploader)
        this.isUploadSubtitleDialog = true
      else {
        // notify(this, 'Error', this.$t('openSubtitleDialogError'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('openSubtitleDialogError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async deleteSubtitle(item) {
      try {
        let resultClip = await deleteSubtitle(
          this,
          this.currentMt.wsId,
          this.currentMt.mtId,
          this.currentClip.clipId,
          item.subtId,
          'subtitle'
        )

        if (resultClip && resultClip.clipInfo) {
          this.totalSectionList[this.stIndex].clipList[this.clipIndex].subTitleData = resultClip.clipInfo.subTitleData
          this.setSubTitleData(resultClip.clipInfo.subTitleData)
        }
      } catch (err) {
        console.log(err)
      }
    },
    finishUploadSubtitle(event) {
      this.isUploadSubtitleDialog = false
      this.$emit('finishUploadSubtitle', event)
    },
    // 자막 선택
    selectSubTitle(subtitleData) {
      localStorage.setItem('ccCode', subtitleData.code)
      this.selectedSubtitle = subtitleData.code
      this.$emit('selectSubTitle', subtitleData)
    },
    setShowCaption() {
      this.showCaption = !this.showCaption
      localStorage.setItem('cc', this.showCaption)
      this.$emit('setShowCaption', this.showCaption)
    },
    onVolumeClick() {
      if (!this.isMobile) {
        this.localVolume = this.isMute ? 100 : 0
      }
    },
    removeByClickingSlider() {
      //비디오 seekbar 클릭 시 작동하는 메소드
      this.$store.dispatch('setClickedSummaryTimestamp', null)
      this.$store.dispatch('setClickedSummaryCard', null)

      this.$store.dispatch('setCommentPlayPreview', true)
      this.$store.dispatch('setEmojiPlayOn', true)
      this.$store.dispatch('setClickcmId', false)
      if (window.innerWidth <= 1263) {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        }, 10)
      }

      if (this.boxCommentComponent) this.boxCommentComponent.onRandomAccess(this.seekTime / 1000)
      if (this.boxCommentComponent) this.boxCommentComponent.onCommentRandomAccess(this.seekTime / 1000)
    },

    videoControlBarIcon() {
      return this.$refs.controlBarIcon
    },

    mousedown() {
      this.isSeeking = true
      if (!this.isPauseIcon) {
        this.$store.dispatch('setIsPauseSeek', true)
      }
      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
    },
    mouseup() {
      this.isSeeking = false
      // this.pauseAndResume()
      this.$store.dispatch('setIsPlayerPause', !this.isPlayerPause)
      this.lastSeekTime = 0
    },
    setDragSeekBar(event) {
      if (Math.abs(this.lastSeekTime - event) < 3000) {
        return
      }
      if (this.isSeeking) {
        this.$store.dispatch('setTimeStampSeekTime', event / 1000)
        this.$store.dispatch('setIsRequestSetSeekTime', true)
        this.lastSeekTime = event
      }
    },
    setSeekTime(event) {
      this.$store.dispatch('setTimeStampSeekTime', event / 1000)
      this.$store.dispatch('setIsRequestSetSeekTime', true)
    },
    pauseAndResume() {
      if (this.seeked + 0.01 >= this.$store.getters.duration) {
        this.$store.dispatch('setTimeStampSeekTime', 0)
        this.$store.dispatch('setIsRequestSetSeekTime', true)
        this.$store.dispatch('setSeeked', 0)
      }
      const DRAWN_BOX_REMOVAL_TIME = 2500
      clearTimeout(this.timeOutValueForVideoControlBar)

      this.$store.dispatch('setCommentPlayOn', true)
      this.$store.dispatch('setEmojiPlayPreview', true)
      this.$store.dispatch('setCommentPlayPreview', false)
      this.$store.dispatch('setEmojiPlayOn', false)
      // this.removeByClickingSlider()

      //박스가 그려진 상태에서 재생 버튼 클릭 시 박스 제거 및 댓글 입력 창 스타일링 해제
      this.$store.dispatch('setBoxDrawn', false)

      // 잠시 fadeout 빼기
      this.$store.dispatch('setIsFadeOut', true)

      this.$store.dispatch('setIsEmojiFadeOut', true)

      const timer = setTimeout(() => {
        if (this.boxCommentComponent) this.boxCommentComponent.removeBox()
        clearTimeout(timer)
      }, DRAWN_BOX_REMOVAL_TIME)
      this.timeOutValueForVideoControlBar = timer

      this.$store.dispatch('setIsPlayerPause', !this.isPlayerPause)
      if (this.$refs.play_icon !== undefined && this.$refs.play_icon !== null) this.$refs.play_icon.blur()
    },
    // // isManually 수동으로 작동했는지 여부
    // setSeekTime(time, isManually) {

    // },
    toggleSummary() {
      const wrapSummary = document.querySelector('#wrap-summary')
      wrapSummary.className == 'col' ? (wrapSummary.className = 'hide col') : (wrapSummary.className = 'col')
      this.showSummary = !this.showSummary
    },
    toggleVisualComment() {
      let btnComment = document.querySelectorAll('.btn-visual-comment')
      for (var i = 0; i < btnComment.length; i++) {
        btnComment[i].className =
          btnComment[i].className == 'v-avatar btn-visual-comment'
            ? 'hide v-avatar btn-visual-comment'
            : 'v-avatar btn-visual-comment'
      }
      this.showVisualComment = !this.showVisualComment
    },
    toggleEmoji() {
      let btnEmoji = document.querySelectorAll('.btn-emoji')
      for (var i = 0; i < btnEmoji.length; i++) {
        btnEmoji[i].className = btnEmoji[i].className == 'btn-emoji' ? 'hide btn-emoji' : 'btn-emoji'
      }
      this.showEmoji = !this.showEmoji
    },
  },
  computed: {
    ...mapGetters([
      'isMtOrganizer',
      'isWsOwner',
      'isWsManager',
      'currentClip',
      'currentMt',
      'totalSectionList',
      'sectionIndex',
      'clipIndex',
      'isFullScreen',
      'controlbarIconList',
      'duration',
      'playback',
      'seeked',
      'volume',
      'userInfo',
      'isTranscriptCardClicked',
      'isFeedback',
      'subTitleData',
    ]),
    isMobile() {
      return isMobile()
    },
    isClipUploader() {
      return (
        this.currentClip !== undefined &&
        this.currentClip !== null &&
        this.currentClip.clipUploader &&
        this.currentClip.clipUploader !== null &&
        this.userInfo &&
        this.userInfo !== null &&
        this.currentClip.clipUploader.userId === this.userInfo.userId
      )
    },
    boxCommentComponent() {
      return this.$root.$refs[`BoxComment-${this.stIndex}`]
    },
    commentPlayComponent() {
      return this.$root.$refs[`CommentPlay-${this.sectionIndex}`]
    },
    isPlayerPause() {
      return this.$store.getters.isPlayerPause !== undefined && this.$store.getters.isPlayerPause !== null
        ? this.$store.getters.isPlayerPause
        : false
    },
    isPauseIcon() {
      return this.$store.getters.isPauseIcon !== undefined && this.$store.getters.isPauseIcon !== null
        ? this.$store.getters.isPauseIcon
        : false
    },
    calcSeekTime() {
      return this.seekTime && this.seekTime !== null && this.seekTime > 0
        ? time(Math.floor(this.seekTime / 1000))
        : '00:00'
    },
    calcSeekTime2() {
      return this.seekTime && this.seekTime !== null && this.seekTime > 0 ? this.seekTime / 1000 : '00:00'
    },
    calcDurationTime() {
      return this.duration && this.duration !== null && this.duration > 0 ? time(Math.floor(this.duration)) : '00:00'
    },
    isMute() {
      return this.localVolume === undefined || this.localVolume === null || this.localVolume <= 0
    },
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
    // subTitleData() {
    //   console.log('computed subtitle data : ', this.currentClip['subTitleData'])
    //   return this.currentClip['subTitleData']
    // },
  },

  watch: {
    // isTranscriptCardClicked(val) {
    //   console.log('isTranscriptCardClicked', val)
    //   if (val) {
    //     this.pauseAndResume()
    //   }
    // },

    // seekTime(val) {
    //   console.log('seekTime Watch', val)
    // },

    // seeked(Val) {
    //   console.log('seeked Watch', Val)
    // },

    sectionIndex: {
      deep: true,
      immediate: true,
      handler() {
        this.$store.dispatch('setIsPauseIcon', false)
      },
    },
    localVolume(val) {
      this.$store.dispatch('setVolume', val)
      localStorage.setItem('volume', this.localVolume)
    },
    seeked(val) {
      if (val > 0) this.seekTime = val * 1000
    },
    duration(val) {
      this.totalTime = val
    },
    playback(val) {
      this.$store.dispatch('setPlayback', val && val !== null ? parseFloat(val) : 0)
      this.playbackItem = val
    },
    playbackItem(val) {
      this.$store.dispatch('setPlayback', val && val !== null ? parseFloat(val) : 0)
    },
    subTitleData(val) {
      if (val) {
        this.$emit('setSubTitles')
        this.setSubTitleData(val)
        this.$emit('selectSubTitle', val)
      }
    },
    currentClip: {
      immediate: true,
      handler() {
        this.setSubTitleData(null)
        this.seekTime = 0
        this.removeByClickingSlider()
        // this.callDisplayCommentBox()
        this.$store.dispatch('setBoxDrawn', false)
      },
    },
  },
}
</script>

<style scoped>
.v-btn {
  min-width: 36px !important;
  padding: 0 8px !important;
}
.v-btn >>> span {
  color: #fff;
}
.avatarControlbar {
  border: 3px solid #ff575f !important;
  z-index: 10;
  animation: scaleUp 1s 1;
}
@keyframes scaleUp {
  0% {
    transform: scale(1.3);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}
.container-controlbar .v-icon {
  font-size: 30px;
  color: white;
}
.container-controlbar >>> .v-slider {
  margin-left: 0;
  margin-right: 0;
}
.seek-slider >>> .v-slider__thumb {
  visibility: hidden;
}
.seek-slider >>> .v-slider__track-background {
  height: 6px;
  cursor: pointer;
}
.seek-slider >>> .v-slider__track-fill {
  height: 6px;
  cursor: pointer;
  background-color: #25c685 !important;
}
.seek-slider >>> .v-slider--horizontal {
  min-height: 0px !important;
  height: 10px !important;
  margin-bottom: 8px;
}
/* .container-slider {
  z-index: 199;
} */
.container-slider >>> .v-input__slot {
  /* height: 4px !important; */
  height: 10px !important;
  /* cursor: pointer; */
}
.container-controlbar {
  font-size: 14px;
  color: white;
  background: #22323b;
}
.v-list-item {
  min-height: 30px !important;
}
.v-menu__content .v-list-item__title {
  font-size: 13px;
  line-height: 20px !important;
}
.container-controlbar >>> .v-slider__thumb-label {
  font-size: 14px;
  /* color: var(--v-primary-base); */
}
.container-controlbar >>> .v-input__icon--prepend .v-icon {
  /* font-size: 40px; */
  color: white;
}
.container-duration {
  border-radius: 5px;
  background: #1f2e35;
  height: 22px;
}
.playback-select {
  min-width: 40px !important;
}
#btn-fullscreen >>> span,
#btn-play >>> span,
#btn-mute >>> span,
.playback-select >>> span,
.cc-select >>> span {
  font-weight: 400;
  color: white;
}
.cc-select >>> span {
  color: #fff;
}
.playback-select >>> span {
  font-weight: 400;
  font-size: 12px;
}
@media (max-width: 959px) {
  .v-btn {
    width: 34px !important;
    min-width: 32px !important;
  }
  .playback-select,
  .cc-select {
    min-width: 35px !important;
  }
  .playback-select >>> span,
  .cc-select >>> span {
    font-weight: 500;
    font-size: 10px;
  }
}
.container-comment-avatar {
  position: relative;
  min-height: 25px;
}
.btn-uploadCc >>> .v-list-item__title {
  color: #eee;
  font-size: 13px !important;
  font-weight: 500 !important;
  transition: all 0.3s;
}
.btn-uploadCc:hover >>> .v-list-item__title {
  color: #fff;
  transition: all 0.3s;
}
.btn-uploadCc {
  transition: all 0.3s;
}
.btn-uploadCc:hover {
  background-color: #161d21;
  transition: all 0.3s;
}
.v-tooltip__content {
  top: 8px !important;
}
.v-tooltip__content >>> span {
  font-size: 12px !important;
  font-weight: 400;
}
#btn-mute >>> .v-tooltip__content {
  top: -30px !important;
  left: -16px !important;
}
#btn-play >>> .v-tooltip__content {
  top: -30px !important;
  left: -4px !important;
}
#btn-fullscreen >>> .v-tooltip__content {
  top: -30px !important;
  left: -57px !important;
}
.v-menu__content {
  border-radius: 5px;
  border: 1px solid #475e69;
}
</style>
